import axios from 'axios';

const api = axios.create({
    baseURL: "https://api.rahebehesht.com/"
});

export default api;